export { default } from './learnImageSlice';
